export const GENERAL_OUTLOOK_ID = "general";

export const FISHING_INTELLIGENCE_SPECIES = Object.freeze([
  Object.freeze({
    id: "dicentrarchus_labrax",
    translationKey: "fishing_today_species_european_sea_bass",
    scientificName: "Dicentrarchus labrax",
  }),
  Object.freeze({
    id: "scomber_scombrus",
    contentSpeciesId: "SCOMBER_SCOMBRUS",
    translationKey: "species.atlantic_mackerel",
    scientificName: "Scomber scombrus",
  }),
  Object.freeze({
    id: "cyprinus_carpio",
    contentSpeciesId: "CYPRINUS_CARPIO",
    translationKey: "species.common_carp",
    scientificName: "Cyprinus carpio",
  }),
]);

export const COMMON_CARP_SPECIES_ID = "cyprinus_carpio";

export const isSupportedFishingIntelligenceSpecies = (speciesId) =>
  FISHING_INTELLIGENCE_SPECIES.some((species) => species.id === speciesId);
